var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatsappAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#25D366",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.077 27.236h-.004c-1.742 0-3.453-.437-4.973-1.266l-5.517 1.447 1.477-5.393a10.387 10.387 0 0 1-1.39-5.202c.003-5.737 4.671-10.405 10.407-10.405a10.339 10.339 0 0 1 7.36 3.052 10.343 10.343 0 0 1 3.046 7.361c-.002 5.736-4.669 10.404-10.406 10.406zm-4.722-3.15l.316.187a8.636 8.636 0 0 0 4.402 1.206h.004c4.767 0 8.647-3.88 8.649-8.65a8.597 8.597 0 0 0-2.531-6.118 8.59 8.59 0 0 0-6.115-2.537c-4.77 0-8.65 3.88-8.652 8.649-.001 1.634.456 3.226 1.322 4.603l.206.327-.874 3.191 3.273-.858zm9.964-4.781c-.065-.109-.238-.174-.498-.304s-1.538-.759-1.777-.846c-.238-.087-.411-.13-.585.13-.173.26-.671.846-.823 1.02-.152.173-.303.195-.563.065-.26-.13-1.098-.405-2.091-1.29-.773-.69-1.295-1.542-1.447-1.802-.151-.26-.016-.4.114-.53.117-.117.26-.304.39-.456.13-.152.174-.26.26-.434.087-.173.044-.325-.021-.455s-.585-1.41-.802-1.931c-.211-.507-.425-.438-.585-.446-.152-.008-.325-.01-.498-.01a.955.955 0 0 0-.694.326c-.238.26-.91.89-.91 2.169 0 1.28.932 2.516 1.062 2.69.13.173 1.833 2.8 4.442 3.926.62.268 1.104.428 1.482.547.623.198 1.19.17 1.638.104.5-.075 1.538-.63 1.755-1.237.216-.607.216-1.128.151-1.236z",
    fill: "#FDFDFD"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappAlt);
export default __webpack_public_path__ + "static/media/whatsapp-alt.641dedcc0b411846a8cdc90d7cbd6cfa.svg";
export { ForwardRef as ReactComponent };